const GlobalNotificationTimer = 2000;

export default GlobalNotificationTimer;
